import { contributorTasks, type ContributorTask } from "@/features/contributor-tasks/contributor-tasks";

/**
 * Keys of contributorTasks(): the kit names a task by the same key as the
 * header, the home grid and the phone task sheet.
 */
export type ContributionTaskKey =
  | "speak"
  | "verifyAudio"
  | "transcribe"
  | "translate"
  | "verifyText"
  | "images"
  | "answerAudio"
  | "answerText"
  | "transcribeInitial"
  | "reviewInitial";

/** The task entry (label, icon, route) for a key, in the given UI language. */
export function findContributorTask(lang: string, key: ContributionTaskKey): ContributorTask {
  const tasks = contributorTasks(lang);
  // contributor-tasks.test.ts guarantees every key exists.
  return tasks.find((task) => task.key === key) ?? tasks[0];
}
